import React, { useEffect, useState } from 'react';
import { Paper, Grid, Typography, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { has, filter, includes } from 'lodash';
import IS from '../ImageService'
const useStyles = makeStyles((theme) => ({
    imageContainer: {
        width: 200
    },
    imageCover: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    }
}));
export default function ImageCard(props) {
    const [image, setImage] = useState(null);
    const classes = useStyles();
    useEffect(() => {
        async function getImage() {
            if (has(props.media, "assetKey")) setImage(await IS(props.media.assetKey))
        }
        getImage();
    }, [props.media]);


    if (!props.media) return null;
    return <div className="imageContainer"><img className="imageCover" src={image} /><div>{props.media.memberId}</div></div>




}